import React, { useState } from 'react';
import { Button } from 'antd';

import TenantBuildingAddDialog from '@totem/components/tenants/tenantsPage/TenantBuildingAddDialog';
import { Tenant } from '@totem/components/tenants/types';
import IBDIcon from '@totem/styles/Icon';

type Props = {
  tenant: Tenant;
};

const TenantBuildingAddButton = ({ tenant }: Props) => {
  const [showAdd, setShowAdd] = useState(false);

  return (
    <>
      <Button icon={<IBDIcon name="Add" />} onClick={() => setShowAdd(true)}>
        Add Building
      </Button>
      {showAdd === true && (
        <TenantBuildingAddDialog
          open={showAdd}
          onClose={() => setShowAdd(false)}
          tenant={tenant}
        />
      )}
    </>
  );
};

export default TenantBuildingAddButton;
